import { useState } from 'react';

import { ChoiceSelect } from '../../components/ui.tsx';
import type { Workbench } from '../useWorkbench.ts';

/** The team a board, plan list or brief list belongs to; "solo" is the person's own. */
export function useTeamChoice(w: Workbench): [string, (id: string) => void] {
  const [choice, setChoice] = useState<string>();
  const first = w.status.data?.teams[0]?.id;
  return [choice ?? first ?? 'solo', setChoice];
}

export function TeamPicker({ w, teamId, onChange }: { w: Workbench; teamId: string; onChange: (id: string) => void }) {
  const teams = w.status.data?.teams ?? [];
  return (
    <ChoiceSelect label="Team" value={teamId} options={{ ...Object.fromEntries(teams.map((t) => [t.id, t.name])), solo: 'Solo' }} onChange={onChange} />
  );
}
